module.exports = __webpack_public_path__ + "img/shop5.af7b4fb5.png";